import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { StyledTagGroup } from "./TagGroup.styles.mjs.mjs";
export const TagGroup = React.forwardRef(function TagGroup({ children, role, ...restProps }, ref) {
    const tagProps = {
        role,
        ref,
        outerSpacing: useSpacing(restProps),
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    return React.createElement(StyledTagGroup, { ...tagProps }, children);
});
//# sourceMappingURL=TagGroup.mjs.mjs.map